"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var async_1 = require("../viewUtils/async");
var selectLinkType_1 = require("./selectLinkType");
var CLASS_NAME = 'ontodia-edit-form';
var ELEMENT_TYPE = '';
var LINK_TYPE = '';
var EditElementTypeForm = /** @class */ (function (_super) {
    tslib_1.__extends(EditElementTypeForm, _super);
    function EditElementTypeForm(props) {
        var _this = _super.call(this, props) || this;
        _this.cancellation = new async_1.Cancellation();
        _this.onElementTypeChange = function (e) {
            var type = e.target.value;
            _this.setState({ elementData: tslib_1.__assign({}, _this.state.elementData, { types: [type] }) });
        };
        _this.state = { elementData: props.target, linkData: props.link, elementTypes: [] };
        return _this;
    }
    EditElementTypeForm.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, metadataApi = _a.metadataApi, source = _a.source;
        if (!metadataApi) {
            return;
        }
        metadataApi.typesOfElementsDraggedFrom(source, this.cancellation.signal).then(function (elementTypes) {
            _this.setState({ elementTypes: elementTypes });
        });
    };
    EditElementTypeForm.prototype.renderElementType = function () {
        var view = this.props.view;
        var elementData = this.state.elementData;
        var value = elementData.types.length ? elementData.types[0] : '';
        return (React.createElement("label", null,
            "Element type",
            React.createElement("select", { className: 'ontodia-form-control', value: value, onChange: this.onElementTypeChange },
                React.createElement("option", { value: '', disabled: true }, "Select element type"),
                this.state.elementTypes.map(function (elementType) {
                    var type = view.model.createClass(elementType);
                    var label = view.getElementTypeLabel(type).text;
                    return React.createElement("option", { key: elementType, value: elementType }, label);
                }))));
    };
    EditElementTypeForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, view = _a.view, metadataApi = _a.metadataApi, source = _a.source;
        var _b = this.state, elementData = _b.elementData, linkData = _b.linkData;
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: CLASS_NAME + "__body" },
                React.createElement("div", { className: CLASS_NAME + "__form-row" }, this.renderElementType()),
                React.createElement("div", { className: CLASS_NAME + "__form-row" },
                    React.createElement(selectLinkType_1.SelectLinkType, { view: view, metadataApi: metadataApi, link: linkData, source: source, target: elementData, onChange: function (data) { return _this.setState({ linkData: data }); } }))),
            React.createElement("div", { className: CLASS_NAME + "__controls" },
                React.createElement("button", { className: "ontodia-btn ontodia-btn-success " + CLASS_NAME + "__apply-button", onClick: function () { return _this.props.onApply(elementData, linkData); }, disabled: elementData.types.indexOf(ELEMENT_TYPE) >= 0 || linkData.linkTypeId === LINK_TYPE }, "Apply"),
                React.createElement("button", { className: 'ontodia-btn ontodia-btn-danger', onClick: this.props.onCancel }, "Cancel"))));
    };
    return EditElementTypeForm;
}(React.Component));
exports.EditElementTypeForm = EditElementTypeForm;
